import React from 'react'

function NotFound() {
    return (
        <div id="Container">
            <h1>404 Not Found</h1>
            <body>
                Deze pagina is (nog) niet beschikbaar.<br />
                <img src={"https://www.ionos.com/digitalguide/fileadmin/DigitalGuide/Teaser/not-found-t.jpg"} alt="404" />
            </body>
        </div >
    )
}

export default NotFound
